module.exports = __webpack_public_path__ + "static/img/CHATGP.f59e236.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/CHATGP.jpg
// module id = VcuD
// module chunks = 1